/* eslint-disable */
import * as Types from '../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AttachInvitationToPairingMutationVariables = Types.Exact<{
  input: Types.AttachInvitationToPairingInput;
}>;


export type AttachInvitationToPairingMutation = { attachInvitationToPairing: { __typename: 'AttachInvitationToPairingResult', ok: boolean, error?: Types.InvitationPairingAttachError | null } };


export const AttachInvitationToPairingDocument = gql`
    mutation AttachInvitationToPairing($input: AttachInvitationToPairingInput!) {
  attachInvitationToPairing(input: $input) {
    ok
    error
  }
}
    `;
export type AttachInvitationToPairingMutationFn = Apollo.MutationFunction<AttachInvitationToPairingMutation, AttachInvitationToPairingMutationVariables>;

/**
 * __useAttachInvitationToPairingMutation__
 *
 * To run a mutation, you first call `useAttachInvitationToPairingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachInvitationToPairingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachInvitationToPairingMutation, { data, loading, error }] = useAttachInvitationToPairingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttachInvitationToPairingMutation(baseOptions?: Apollo.MutationHookOptions<AttachInvitationToPairingMutation, AttachInvitationToPairingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachInvitationToPairingMutation, AttachInvitationToPairingMutationVariables>(AttachInvitationToPairingDocument, options);
      }
export type AttachInvitationToPairingMutationHookResult = ReturnType<typeof useAttachInvitationToPairingMutation>;
export type AttachInvitationToPairingMutationResult = Apollo.MutationResult<AttachInvitationToPairingMutation>;
export type AttachInvitationToPairingMutationOptions = Apollo.BaseMutationOptions<AttachInvitationToPairingMutation, AttachInvitationToPairingMutationVariables>;